import {
  CHANGE_VISIBLE_BALANCE,
  CHANGE_VISIBLE_MOB_NAV,
  CHANGE_VISIBLE_NAV,
  CHANGE_POSITION_MENU,
  CHANGE_JACKPOTS_VISIBLE,
  CHANGE_VISIBLE_SWEEPSTAKES_MOB_NAV,
} from "@shared/constants";

const initialState = {
  isBalanceVisible: true,
  isGameMenuVisible: true,
  isNavigationVisible: true,
  isNavigationSweepstakesVisible: false,
  isJackpotsVisible: false,
  menuPosition: "right",
};

function userInterfaceProviderReducer(state = initialState, action) {
  switch (action.type) {
    case CHANGE_VISIBLE_BALANCE:
      return {
        ...state,
        isBalanceVisible: action.payload,
      };

    case CHANGE_VISIBLE_MOB_NAV:
      return {
        ...state,
        isGameMenuVisible: action.payload,
      };

    case CHANGE_VISIBLE_SWEEPSTAKES_MOB_NAV:
      return {
        ...state,
        isNavigationSweepstakesVisible: action.payload,
      };

    case CHANGE_VISIBLE_NAV:
      return {
        ...state,
        isNavigationVisible: action.payload,
      };

    case CHANGE_POSITION_MENU: {
      return {
        ...state,
        menuPosition: action.payload,
      };
    }

    case CHANGE_JACKPOTS_VISIBLE: {
      return {
        ...state,
        isJackpotsVisible: action.payload,
      };
    }

    default:
      return state;
  }
}

export default userInterfaceProviderReducer;
